// React
import React, { useEffect, useState } from 'react';

// Libs
import { Icon } from 'semantic-ui-react';

// Styles
import styles from './LeadsFilter.module.css';

// Types
type LeadsSortingComponentProps = {
    dataKey: string;
    onSort: (v: Array<string>) => void;
};

/**
 * It is a component which shows sorting arrows and handle sort event by user's click.
 *
 * @param props LeadsSortingComponentProps
 * @returns React.ReactElement
 */
export default function LeadsSortingComponent(props: LeadsSortingComponentProps): React.ReactElement {
    const [sort, setSort] = useState<string | undefined>(undefined);

    useEffect(() => {
        const key = props.dataKey === 'customerFullName' ? 'customerLastName' : props.dataKey;
        if (sort) {
            props.onSort([key, sort]);
        }
    }, [sort]);

    return (
        <div className={styles.sorter}>
            <Icon
                className={styles.sorterButton}
                name="sort up"
                data-testid={`sort-up-${props.dataKey}`}
                onClick={() => setSort('asc')}
            />
            <Icon
                className={styles.sorterButton}
                name="sort down"
                data-testid={`sort-down-${props.dataKey}`}
                onClick={() => setSort('desc')}
            />
        </div>
    );
}
